<template>
  <div>
    <app-form-field :id="`${quoteNamespace}_quote-remark`" :title="remarkLabel" :show-label="false">
      <form-text-area
        :id="`${quoteNamespace}_quote-remark`"
        v-model="remark"
        data-qa="quote-remark-input"
        :title="remarkLabel"
        rows="2"
        :disabled="quoteStatusIsSalesOrder || isLoading || null"
        @change="updateRemark"
      />
    </app-form-field>
  </div>
</template>

<script>
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import FormTextArea from '@/components/generic/presentational/atoms/formTextarea/FormTextarea.vue'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import { mapState } from 'vuex'

export default {
  components: {
    AppFormField,
    FormTextArea,
  },
  mixins: [AdditionalOrder],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isLoading: true,
      remark: '',
    }
  },
  computed: {
    // Dynamic namespaces aren't supported by mapGetters
    ...mapState({
      quote(state, getters) {
        return getters[this.quoteNamespace + '/get']
      },
      quoteStatusIsSalesOrder(state, getters) {
        return getters[this.quoteNamespace + '/quoteStatusIsSalesOrder']
      },
    }),
    remarkLabel() {
      return this.i18n.t(
        this.additionalQuote ? '/additionalorder/additional order remarks' : '/TotalPrice/Remark'
      )
    },
  },
  created() {
    this.remark = this.quote?.QuoteDetails?.Remark
    this.isLoading = false
  },
  methods: {
    updateRemark(event) {
      this.$store.dispatch(`${this.quoteNamespace}/setRemark`, this.remark)
    },
  },
}
</script>
